import React from "react";
import { Card, Button, Modal, message, Popconfirm } from "antd";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Row, Col, Form, FormGroup, Label, Input, } from 'reactstrap';
import Media from 'react-media';

import { services } from '../../../services/services';
import { use_logiciel } from '../../../env'




class Agences extends React.Component {
  state = {
    isModalVisible: false,
    isAddModalVisible: false,
    isUpdateModalVisible: false,
    loading: false,
    agences: [],

    usuel: "1",
    codTyp: "1",
    nomAgence: '',
    codeCat: '',
    nomGerant: '',
    codificationAgence: '',
    adrAgence: '',
    telAgence: '',
    telGerant: '',
    observation: '',
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  componentDidMount() {
    services.getAllAgences()
      .then(agences => {
        // console.log('agences', agences)
        this.setState({ agences })
      })


  }
  handleAddOpen = () => {
    this.setState({ isAddModalVisible: !this.state.isAddModalVisible, });
  };

  handleCancelAdd = () => {
    this.setState({
      isAddModalVisible: !this.state.isAddModalVisible,
      codAgence: '',
      codificationAgence: '',
      nomAgence: '',
      adrAgence: '',
      telAgence: '',
      nomGerant: '',
      telGerant: '',
      observation: '',

    })
  }

  handleAddAgence = () => {
    const {
      //codAgence,
      codificationAgence,
      nomAgence,
      adrAgence,
      telAgence,
      nomGerant,
      telGerant,
      observation,
    } = this.state


    if (nomAgence === '') {
      message.warning('Veuillez préciser le nom de l\'Agence', 5)
      return;
    }
    /*if (codAgence === '') {
      message.warning('Veuillez sélectionner une Agence', 5)
      return;
    }*/

    this.setState({ loading: true })

    let req = {
      //codAgence,
      codificationAgence: codificationAgence.toUpperCase(),
      nomAgence: nomAgence.toUpperCase(),
      adrAgence,
      telAgence,
      nomGerant,
      telGerant,
      observation,
      //raisonSociale: raisonSociale.toUpperCase(),

    }
    services.addAgence(req)
      .then(result => {
        // console.log(result)
        this.setState({
          codAgence: '',
          codificationAgence: '',
          nomAgence: '',
          adrAgence: '',
          telAgence: '',
          nomGerant: '',
          telGerant: '',
          observation: '',
          loading: false,
          isAddModalVisible: !this.state.isAddModalVisible,

        })
        message.success('Agences ajouter avec succès', 10)

        services.getAllAgences()
          .then(agences => {
            this.setState({ agences })
          })

      })

      .catch((err) => {
        this.setState({ loading: false })
        message.error(err, 10)
        
      });
  }

  handleUpdateAgence = () => {
    const {
      //idAgence,
      codAgence,
      codificationAgence,
      nomAgence,
      adrAgence,
      telAgence,
      nomGerant,
      telGerant,
      observation,
    } = this.state


    if (nomAgence === '') {
      message.warning('Veuillez préciser le nom de l\'Agence', 5)
      return;
    }
    if (codAgence === '') {
      message.warning('Veuillez sélectionner le Code de l\'Agence', 5)
      return;
    }
    /* if (observation === '') {
       message.warning('Veuillez préciser l\'Observation', 5)
       return;
     }
     if (telGerant === '') {
       message.warning('Veuillez préciser le Téléphone du Gérant', 5)
       return;
     }
     if (nomGerant === '') {
       message.warning('Veuillez préciser le Nom du Gérant', 5)
       return;
     }
     if (adrAgence === '') {
       message.warning('Veuillez préciser l\'Adresse de l\'Agence', 5)
       return;
     }
     if (codificationAgence === '') {
       message.warning('Veuillez renseigner le champ Codification', 5)
       return;
     }
 */
    let req = {
      //idAgence,
      codAgence,
      codificationAgence: codificationAgence.toUpperCase(),
      nomAgence: nomAgence.toUpperCase(),
      adrAgence,
      telAgence,
      nomGerant,
      telGerant,
      observation,

    }
    services.updateAgence(codAgence, req)
      .then(result => {
        // console.log(result)
        this.setState({
          idAgence: '',
          codAgence: '',
          codificationAgence: '',
          nomAgence: '',
          adrAgence: '',
          telAgence: '',
          nomGerant: '',
          telGerant: '',
          observation: '',
          isUpdateModalVisible: !this.state.isUpdateModalVisible,

        })
        message.success('Agences modifier avec succès', 10)

        services.getAllAgences()
          .then(agences => {
            this.setState({ agences })
          })

      })

      .catch(() => {
        message.error('Une erreur est survenue lors de la modification, Veuillez réessayer plus tard', 10)
      });
  }

  handleDelete = (row) => {
    this.setState({
      codAgence: row.codAgence,
      nomAgence: row.nomAgence,
    })

  }

  handleDeleteAgence = () => {

    const { codAgence } = this.state

    services.deleteAgence(codAgence)
      .then(del => {
        //console.log('delete user', del)
        message.success('Agence supprimer avec succès', 10)
        services.getAllAgences()
          .then(agences => {
            this.setState({ agences })
          })

      })
      .catch((err) => {
        message.error(err, 10)
      });

  }

  handleUpdateOpen = (row) => {
    this.setState({
      isUpdateModalVisible: !this.state.isUpdateModalVisible,
      //idAgence: row.id,
      codAgence: row.codAgence,
      codificationAgence: row.codificationAgence,
      nomAgence: row.nomAgence,
      adrAgence: row.adrAgence,
      telAgence: row.telAgence,
      nomGerant: row.nomGerant,
      telGerant: row.telGerant,
      observation: row.observation,

    })

  }
  handleCancelUpdate = () => {
    this.setState({
      isUpdateModalVisible: !this.state.isUpdateModalVisible,
      codAgence: '',
      codificationAgence: '',
      nomAgence: '',
      adrAgence: '',
      telAgence: '',
      nomGerant: '',
      telGerant: '',
      observation: '',
    })
  }


  handleView = (row) => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      codAgence: row.codAgence,
      codificationAgence: row.codificationAgence,
      nomAgence: row.nomAgence,
      adrAgence: row.adrAgence,
      telAgence: row.telAgence,
      nomGerant: row.nomGerant,
      telGerant: row.telGerant,
      observation: row.observation,


    });
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      codAgence: '',
      codificationAgence: '',
      nomAgence: '',
      adrAgence: '',
      telAgence: '',
      nomGerant: '',
      telGerant: '',
      observation: '',
    });
  }


  render() {
    const {
      isModalVisible,
      loading,
      codAgence,
      codificationAgence,
      nomAgence,
      adrAgence,
      telAgence,
      nomGerant,
      telGerant,
      observation,

      agences,


      isAddModalVisible,
      isUpdateModalVisible
    } = this.state


    //const Option = Select.Option;

    const { SearchBar } = Search;

    const columnsAgences = [
      /*{
      dataField: 'id',
      text: ' ID'
    },*/ {
        dataField: 'codAgence',
        text: ' Code'
      }, {
        dataField: 'codificationAgence',
        text: ' Codification '
      },
      {
        dataField: 'nomAgence',
        text: ' Désignation '
      },
      {
        dataField: 'telAgence',
        text: 'Téléphone'
      },
      {
        dataField: 'adrAgence',
        text: ' Adresse'
      },


      {
        dataField: '',
        text: 'Action',
        headerAlign: 'center',
        sort: true,
        headerAttrs: { width: 50 },
        align: 'center',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            < div
              style={{ textAlign: "center" }} className="d-flex">
              <Button

                //hidden= { use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="primary"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleView(row)}
              >
                <i className="icon icon-custom-view" />
              </Button>
              <Button
                hidden={use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="danger"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleUpdateOpen(row)}
              >
                <i className="icon icon-edit" />
              </Button>
              <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Agence?" onConfirm={this.handleDeleteAgence} onCancel={this.cancelDelete} okText="Oui"
                cancelText="Non">
                <Button
                  hidden={use_logiciel === 'NO' ? false : true}
                  type="danger"
                  //fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  //className="btn btn-success btn-sm"
                  onClick={() => this.handleDelete(row)}
                >
                  <i className="icon icon-alert-new" />
                </Button>

              </Popconfirm>

            </div>
          );
        },

      }

    ];


    const columnsAgencesPhone = [

      {
        dataField: 'nomAgence',
        text: ' Agence'
      },


      {
        dataField: '',
        text: 'Action',
        headerAlign: 'center',
        sort: true,
        headerAttrs: { width: 50 },
        align: 'center',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            < div
              style={{ textAlign: "center" }} className="d-flex">
              <Button
                type="primary"
                //fullWidth
                variant="contained"
                color="primary"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleView(row)}
              >
                <i className="icon icon-custom-view" />
              </Button>
              <Button
                hidden={use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="danger"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleUpdateOpen(row)}
              >
                <i className="icon icon-edit" />
              </Button>
              <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Agence?" onConfirm={this.handleDeleteAgence} onCancel={this.cancelDelete} okText="Oui"
                cancelText="Non">
                <Button
                  hidden={use_logiciel === 'NO' ? false : true}
                  type="danger"
                  //fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  //className="btn btn-success btn-sm"
                  onClick={() => this.handleDelete(row)}
                >
                  <i className="icon icon-alert-new" />
                </Button>

              </Popconfirm>

            </div>
          );
        },

      }

    ];

    const defaultSorted = [{
      dataField: 'nomAgence',
      order: 'asc'
    }];



    return (
      <div>
        <Card title="Liste des Agences">

          <Media query="(min-width: 600px)" render={() =>
          (
            <ToolkitProvider
              keyField="id"
              data={agences}
              columns={columnsAgences}
              //cellEdit={cellEditFactory({ mode: 'dbclick' })}
              search
              //insertRow={true}
              exportCSV

            >
              {
                props => (
                  <div>
                    <Row >
                      <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                        {/*<i className="fa fa-search" style={{ margin: 10 }}></i> */}

                        <SearchBar {...props.searchProps}
                          //delay={ 1000 }
                          style={{ maxWidth: 750, width: '180%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                          placeholder="Rechercher"

                        />
                      </Col>
                      {use_logiciel === 'NO' &&  //currentUser && currentUser.slug === 'COMMERCIAL_ROLE' &&
                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                          <button style={{ marginLeft: 3 }}
                            className="btn bg-primary text-light rounded"
                            onClick={this.handleAddOpen}>
                            NOUVEAU <i className="icon icon-add" />
                          </button>
                        </Col>

                      }
                    </Row>


                    <BootstrapTable
                      {...props.baseProps}
                      //bootstrap4
                      wrapperClasses="table-responsive"
                      //selectRow={ selectRow }
                      //defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      defaultSorted={defaultSorted}
                      striped
                      hover
                      condensed
                      headerWrapperClasses="foo"
                      noDataIndication="Vous n'avez aucun enrégistrement, veuillez cliquer sur Nouveau pour en ajouter"
                    //filter={filterFactory()}
                    />

                  </div>

                )
              }
            </ToolkitProvider>
          )}
          />


          <Media query="(max-width: 599px)" render={() =>
          (

            <ToolkitProvider
              keyField="id"
              data={agences}
              columns={columnsAgencesPhone}
              //cellEdit={cellEditFactory({ mode: 'dbclick' })}
              search
              //insertRow={true}
              exportCSV

            >
              {
                props => (
                  <div>
                    <Row >
                      <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                        <i className="fa fa-search" style={{ margin: 10 }}></i>

                        <SearchBar {...props.searchProps}
                          //delay={ 1000 }
                          style={{ maxWidth: 450, width: '125%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                          placeholder="Rechercher"

                        />
                      </Col>
                      {//currentUser && currentUser.slug === 'COMMERCIAL_ROLE' &&
                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                          <button style={{ marginLeft: 3 }}
                            className="btn bg-primary text-light rounded"
                            onClick={this.handleAddOpen}>
                            NOUVEAU <i className="icon icon-add" />
                          </button>
                        </Col>
                      }

                    </Row>

                    <BootstrapTable
                      {...props.baseProps}
                      //bootstrap4
                      wrapperClasses="table-responsive"
                      //selectRow={ selectRow }
                      //defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      defaultSorted={defaultSorted}
                      striped
                      hover
                      condensed
                      headerWrapperClasses="foo"
                      noDataIndication="Vous n'avez aucun enrégistrement, veuillez cliquer sur Nouveau pour en ajouter"
                    //filter={filterFactory()}
                    />

                  </div>

                )
              }
            </ToolkitProvider>
          )}
          />
        </Card>


        <Modal
          width={800}
          visible={isAddModalVisible}
          title="Ajouter une Agence"
          //onOk={this.handleAddOpen}
          onCancel={this.handleCancelAdd}
          footer={[
            <Button  type="primary" loading={loading} onClick={this.handleAddAgence}>
              Envoyer
            </Button>,
            <Button  type="danger" onClick={this.handleCancelAdd}>
              Annuler
            </Button>,

          ]}
        >
          <Form>
            <Row form>
              {/*<Col md={6}>
                <FormGroup>
                  <Label for="codAgence">Code Agence</Label>
                  <Input type="text" name="codAgence" id="codAgence" value={codAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
        </Col>*/}
              <Col md={4}>
                <FormGroup>
                  <Label for="codificationAgence">Codification</Label>
                  <Input type="text" name="codificationAgence" value={codificationAgence} id="codificationAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label for="nomAgence">Nom Agence</Label>
                  <Input type="text" name="nomAgence" value={nomAgence} onChange={this.handleChange} id="nomAgence" placeholder="" />
                </FormGroup>
              </Col>
            </Row>



            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="adrAgence">Adresse</Label>
                  <Input type="text" name="adrAgence" id="adrAgence" value={adrAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="telAgence">Téléphone</Label>
                  <Input type="number" name="telAgence" value={telAgence} id="telAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <Row form>

              <Col md={6}>
                <FormGroup >
                  <Label for="nomGerant">Nom Gérant</Label>
                  <Input type="text" name="nomGerant" value={nomGerant} id="nomGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="telGerant">Téléphone Gérant</Label>
                  <Input type="number" name="telGerant" value={telGerant} id="telGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input type="text" name="observation" value={observation} id="observation" onChange={this.handleChange} placeholder="" />
            </FormGroup>

          </Form>
        </Modal>

        <Modal
          width={800}
          visible={isUpdateModalVisible}
          title="Modifier l'Agence"
          //onOk={this.handleAddOpen}
          onCancel={this.handleCancelUpdate}
          footer={[
            <Button  type="primary" loading={loading} onClick={this.handleUpdateAgence}>
              Modifier
            </Button>,
            <Button  type="danger" onClick={this.handleCancelUpdate}>
              Annuler
            </Button>,

            /*<Button
             key="link"
             href="https://google.com"
             type="primary"
             loading={loading}
             onClick={this.handleOk}
           >
             Search on Google
           </Button>,*/
          ]}
        >
          <Form>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="codAgence">Code Agence</Label>
                  <Input disabled type="text" name="codAgence" id="codAgence" value={codAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="codificationAgence">Codification</Label>
                  <Input type="text" name="codificationAgence" value={codificationAgence} id="codificationAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="nomAgence">Nom Agence</Label>
              <Input type="text" name="nomAgence" value={nomAgence} onChange={this.handleChange} id="nomAgence" placeholder="" />
            </FormGroup>

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="adrAgence">Adresse</Label>
                  <Input type="text" name="adrAgence" id="adrAgence" value={adrAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="telAgence">Téléphone</Label>
                  <Input type="number" name="telAgence" value={telAgence} id="telAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <Row form>

              <Col md={6}>
                <FormGroup >
                  <Label for="nomGerant">Nom Gérant</Label>
                  <Input type="text" name="nomGerant" value={nomGerant} id="nomGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="telGerant">Téléphone Gérant</Label>
                  <Input type="number" name="telGerant" value={telGerant} id="telGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input type="text" name="observation" value={observation} id="observation" onChange={this.handleChange} placeholder="" />
            </FormGroup>


          </Form>
        </Modal>

        <Modal
          width={800}
          visible={isModalVisible}
          title="Détails Agence"
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          footer={[
            <Button  type="danger" onClick={this.handleCancel}>
              Retour
            </Button>,
            /*<Button  type="primary" loading={loading} onClick={this.handleCancel}>
              Envoyer
            </Button>,
            <Button
              key="link"
              href="https://google.com"
              type="primary"
              loading={loading}
              onClick={this.handleOk}
            >
              Search on Google
            </Button>,*/
          ]}
        >
          <Form>
            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="codAgence">Code Agence</Label>
                  <Input disabled type="text" name="codAgence" id="codAgence" value={codAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="codificationAgence">Codification</Label>
                  <Input disabled type="text" name="codificationAgence" value={codificationAgence} id="codificationAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="nomAgence">Nom Agence</Label>
              <Input disabled type="text" name="nomAgence" value={nomAgence} onChange={this.handleChange} id="nomAgence" placeholder="" />
            </FormGroup>

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="adrAgence">Adresse</Label>
                  <Input disabled type="text" name="adrAgence" id="adrAgence" value={adrAgence} onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="telAgence">Téléphone</Label>
                  <Input disabled type="number" name="telAgence" value={telAgence} id="telAgence" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <Row form>

              <Col md={6}>
                <FormGroup >
                  <Label for="nomGerant">Nom Gérant</Label>
                  <Input disabled type="text" name="nomGerant" value={nomGerant} id="nomGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="telGerant">Téléphone Gérant</Label>
                  <Input disabled type="number" name="telGerant" value={telGerant} id="telGerant" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="observation">Observation</Label>
              <Input disabled type="text" name="observation" value={observation} id="observation" onChange={this.handleChange} placeholder="" />
            </FormGroup>


          </Form>
        </Modal>

      </div>
    )
  }
}


export default Agences;
